import api from "./axiosInstance";

export const postRequest = async (url, payload, config = {}) => {
  const { data } = await api.post(url, payload, config);
  return data;
};

export const putRequest = async (url, payload, config = {}) => {
  const { data } = await api.put(url, payload, config);
  return data;
};

export const patchRequest = async (url, payload = {}) => {
  const { data } = await api.patch(url, payload);
  return data;
};

export const deleteRequest = async (url) => {
  const { data } = await api.delete(url);
  return data;
};
